import { Icon, Form } from "semantic-ui-react"
import DatePicker from "react-datepicker"
import { formatDateToMmDdYyyy } from "../../utils/formatDate"

export const IcctDatePicker = props => {
    return <DatePicker
        maxDate={props.maxDate}
        customInput={
            <Form.Input icon={
                <Icon name={props.value ? "times" : "calendar"}
                    link={props.value}
                    onClick={() => props.onChange(props.keyName, null)}
                />} error={props.error}
            />}
        value={props.value ? formatDateToMmDdYyyy(props.value) : ''}
        onChange={(value) => {
            props.onChange(props.keyName, value)
        }}
    />
}